module.exports = __webpack_public_path__ + "img/toplogo.b68690a7.png";